export default __webpack_public_path__ + "static/media/livechat-active.80451086.webp";